import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Translate from '../../../../i18n/Translate/Translate';
import './MainTitle.scss';
import UserData from '../../../../components/UserData/UserData';

const MainTitle = ({ title, subtitle, className }) => (
  <div className={classNames('profile-header d-flex justify-content-between align-items-center', className)}>
    <h1 className="profile-title font-32">
      <Translate translationKey={title} />
      {!!subtitle && (
        <span className="text-uppercase font-14 font-weight-light pl-3">{subtitle}</span>
      )}
    </h1>
    <UserData />
  </div>
);

MainTitle.defaultProps = {
  title: '',
  subtitle: '',
  className: '',
};

MainTitle.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  className: PropTypes.string,
};

export default MainTitle;
